/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Visiontitle1Inputs */

const zh_about_visiontitle1 = /** @type {(inputs: About_Visiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`愿景`)
};

const en_about_visiontitle1 = /** @type {(inputs: About_Visiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vision`)
};

const es_about_visiontitle1 = /** @type {(inputs: About_Visiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visión`)
};

/**
* | output |
* | --- |
* | "Vision" |
*
* @param {About_Visiontitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const about_visiontitle1 = /** @type {((inputs?: About_Visiontitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Visiontitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_visiontitle1(inputs)
	if (locale === "en") return en_about_visiontitle1(inputs)
	return es_about_visiontitle1(inputs)
});
export { about_visiontitle1 as "about_visionTitle" }